import { useCallback } from "react";
import { getDispatchSupplierFacets } from "../services";

export const useSupplierFacets = () => {
  const fetchSupplierFacets = useCallback(async (customerId: string) => {
    try {
      const response = await getDispatchSupplierFacets(customerId);
      return response;
    } catch (error: any) {
      const errorMessage = error?.response?.data?.errorMsg || 
                          error?.response?.data?.message ||
                          error?.response?.data?.error ||
                          error?.message || 
                          "Failed to fetch suppliers for this customer";
      
      throw new Error(errorMessage);
    }
  }, []);

  const findSupplierByName = useCallback(async (customerId: string, supplierName: string) => {
    try {
      const supplierResponse = await fetchSupplierFacets(customerId);
      const targetSupplier = supplierResponse.suppliers?.find(
        (s: any) => s.name === supplierName
      );

      if (!targetSupplier) {
        throw new Error(`Supplier "${supplierName}" not found for this customer. Please verify supplier allocation.`);
      }

      return targetSupplier;
    } catch (error) {
      throw error;
    }
  }, [fetchSupplierFacets]);

  return {
    fetchSupplierFacets,
    findSupplierByName,
  };
}; 